const partnershipType = [
  {
    id: 0,
    title: "General",
    value: "General",
  },
  {
    id: 1,
    title: "Limited",
    value: "Limited",
  },
];

const guarantorStatus = [
  {
    id: 0,
    title: "Yes",
    value: "yes",
  },
  {
    id: 1,
    title: "No",
    value: "no",
  },
];

const partnerType = [
  {
    id: 0,
    title: "Person",
    value: "person",
  },
  {
    id: 1,
    title: "Corporation",
    value: "corporation",
  },
];

const isGuarantor = [
  {
    id: 0,
    title: "Yes",
    value: true,
  },
  {
    id: 1,
    title: "No",
    value: false,
  },
];
export const partnerData = {
  partnershipType,
  guarantorStatus,
  partnerType,
  isGuarantor,
};
